export default __webpack_public_path__ + "static/media/keep-Notes.bd0fbd68.png";